import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {
	const slider = {
		staticBreakpoint: 1351,
		autoplayBreakpoint: 991,
		resizeTimer: null,

		init: function() {
			this.$slider = $('.js-social-slider__slider');
			this.itemCount = this.$slider.children('.social-slider__slide').length;
			this.sliderInit();
			this.bindResize();
		},

		isStaticMode: function() {
			return this.itemCount <= 6 && window.matchMedia(`(min-width: ${this.staticBreakpoint}px)`).matches;
		},

		isInitialized: function() {
			return this.$slider.hasClass('slick-initialized');
		},

		// On touch widths the autoplay timer fights the finger — slick's
		// pauseOnHover never fires there, so it can advance mid-swipe.
		allowsAutoplay: function() {
			return window.matchMedia(`(min-width: ${this.autoplayBreakpoint}px)`).matches;
		},

		applyStaticMode: function() {
			if (this.isInitialized()) {
				this.$slider.slick('unslick');
			}

			this.$slider.addClass('social-slider__slider--static social-slider__slider--compact');
		},

		applySliderMode: function() {
			if (this.isInitialized()) {
				// Slick's responsive settings never touch a running autoplay timer
				// (checkResponsive only re-extends options and calls refresh), so
				// crossing the breakpoint has to pause/play it by hand.
				this.$slider.slick(this.allowsAutoplay() ? 'slickPlay' : 'slickPause');
				return;
			}

			this.$slider.removeClass('social-slider__slider--static social-slider__slider--compact');

			const sliderConfig = {
				slidesToShow: 5,
				slidesToScroll: 1,
				autoplay: this.allowsAutoplay(),
				infinite: this.itemCount > 5,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: 5,
							infinite: this.itemCount > 5
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 4,
							infinite: this.itemCount > 4
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 3,
							infinite: this.itemCount > 3
						}
					}
				]
			};

			sliders.initializeSlider(this.$slider, sliderConfig);
		},

		sliderInit: function() {
			if (!this.$slider.length) {
				return;
			}

			if (this.isStaticMode()) {
				this.applyStaticMode();
				return;
			}

			this.applySliderMode();
		},

		bindResize: function() {
			$(window).on('resize.socialSlider', () => {
				window.clearTimeout(this.resizeTimer);
				this.resizeTimer = window.setTimeout(() => {
					this.sliderInit();
				}, 150);
			});
		},
	};

	slider.init();

});
